import React from 'react';
import { ISVGType } from './SVGType';

const ApprovedTickSVG: React.FC<ISVGType> = (props) => {
  const { height = 12, width = 15, color = "#FFFFFF" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 12"
      fill="none"
    >
      <path
        d="M14.6806 1.21001C14.5876 1.11628 14.477 1.04189 14.3552 0.991122C14.2333 0.940353 14.1026 0.914215 13.9706 0.914215C13.8386 0.914215 13.7079 0.940353 13.586 0.991122C13.4642 1.04189 13.3536 1.11628 13.2606 1.21001L5.81059 8.67001L2.68059 5.53001C2.58407 5.43677 2.47013 5.36346 2.34527 5.31426C2.22042 5.26505 2.08709 5.24092 1.95291 5.24324C1.81873 5.24557 1.68632 5.27429 1.56325 5.32779C1.44017 5.38128 1.32883 5.45849 1.23559 5.55501C1.14235 5.65154 1.06904 5.76548 1.01984 5.89033C0.970631 6.01519 0.946501 6.14851 0.948822 6.28269C0.951144 6.41687 0.979872 6.54928 1.03337 6.67236C1.08686 6.79544 1.16407 6.90677 1.26059 7.00001L5.10059 10.84C5.19356 10.9337 5.30416 11.0081 5.42602 11.0589C5.54787 11.1097 5.67858 11.1358 5.81059 11.1358C5.9426 11.1358 6.07331 11.1097 6.19517 11.0589C6.31703 11.0081 6.42763 10.9337 6.52059 10.84L14.6806 2.68001C14.7821 2.58637 14.8631 2.47272 14.9185 2.34622C14.9739 2.21972 15.0025 2.08312 15.0025 1.94501C15.0025 1.80691 14.9739 1.67031 14.9185 1.54381C14.8631 1.41731 14.7821 1.30366 14.6806 1.21001Z"
        fill={color}
      />
    </svg>
  );
};

export default ApprovedTickSVG;
